import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon'
import { faBuilding, faFireExtinguisher } from '@fortawesome/free-solid-svg-icons'

export const FloorPlanIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faBuilding} color={props.color || 'black'} />
  )
}
